class MC_SliderDiplomas {
 constructor() {
  this.initSlider();
 }
 initSlider() {
  let slider = document.querySelector('.diplomas-covers-slider-wrapper-container');
  if (!slider){
     return
  }
  let sliderContainer = slider.querySelector('.diplomas-covers-slider');
  let sliderElement = slider.querySelectorAll('.diplomas-covers-slider LI');
  let sliderElementWidth = slider.querySelector('.diplomas-covers-slider LI').clientWidth + 10;
  let mobileViewport = window.matchMedia('(max-width: 580px)');
  let prevButton = slider.querySelector('.prev');
  let nextButton = slider.querySelector('.next');
  let currentSlide = 0;
  let stopSlide;

  if (!sliderContainer || !sliderElement.length) {
   return
  }

  function moveSlide() {
   sliderContainer.style.transform = `translateX(${-sliderElementWidth * currentSlide}px)`;
  }

  function autoPlay() {
   currentSlide++;
   if (!mobileViewport.matches) {
    if (currentSlide > sliderElement.length - 3) {
     currentSlide = 0;
    }
   } else {
    if (currentSlide > sliderElement.length - 2) {
     currentSlide = 0;
    }
   }
   moveSlide();
  }

  setInterval(function () {
   stopSlide = false;
   if (stopSlide === true) {
    setInterval(function (){
     stopSlide = false;
    }, 500)
   } else {
    autoPlay();
   }
  }, 6000)

  nextButton.addEventListener('click', function (e) {
   e.preventDefault();
   currentSlide++;

   stopSlide = true;

   if (!mobileViewport.matches) {
    if (currentSlide > sliderElement.length - 3) {
     currentSlide = 0;
    }
   } else {
    if (currentSlide > sliderElement.length - 2) {
     currentSlide = 0;
    }
   }
   moveSlide();
  })

  prevButton.addEventListener('click', function (e) {
   e.preventDefault();
   currentSlide--;

   stopSlide = true;

   if (!mobileViewport.matches) {
    if (currentSlide < 0) {
     currentSlide = sliderElement.length - 3;
    };
   } else {
    if (currentSlide < 0) {
     currentSlide = sliderElement.length - 2;
    }
   }

   moveSlide();
  })
 }
}
